module.exports = __webpack_public_path__ + "static/media/ordernacaoasc.b9e02855.svg";